import assign = require('object-assign');

import {
    Widget as WidgetAction,
    ReportTemplate as ReportTemplateAction,
    Node as NodeAction
} from '../constants';
import { Widget } from '../store/models';
import {
    IWidgetAction,
    IReportTemplateAction
} from '../interfaces/actions';
import { IReportTemplateState } from '../interfaces/states';

import translate from '../locale/translate';
import { formatDate } from '../components/widget/util/StringUtil';

function getInitialState(): IReportTemplateState {
    return {
        rtId: null,
        name: [translate.gettext('Report'), formatDate(new Date(), 'LLL')].join(' '),
        widgets: [],
        byId: {},
        arr: []
    };
}

export default function widgets(state: IReportTemplateState = getInitialState(), action): IReportTemplateState {
    switch (action.type) {
        case ReportTemplateAction.SAVE_SUCCESS:
        case ReportTemplateAction.GET_SUCCESS: {
            const payload = (action as IReportTemplateAction).payload || getInitialState();
            const newWidgets = payload.widgets as Widget[];

            return assign({}, state, {
                rtId: payload.rtId,
                name: payload.name,
                widgets: newWidgets,
                byId: newWidgets.reduce((map, widget: Widget) => {
                    map[widget.id] = widget;
                    return map;
                }, {}),
                arr: newWidgets.map(({id}) => {
                    return id;
                }),
            });
        }
        case ReportTemplateAction.SET_PROPERTY: {
            const rtAction = (action as IReportTemplateAction);

            return assign({}, state, {
                [rtAction.key]: rtAction.value
            });
        }
        case WidgetAction.ADD: {
            const payload = (action as IWidgetAction).payload;
            const addWidget = payload.widget;

            const byId = assign({}, state.byId, {
                [addWidget.id]: addWidget
            });

            const arr = [
                ...state.arr,
                addWidget.id
            ];

            const widgets = arr.map((key: string) => {
                return byId[key];
            });

            return assign({}, state, {
                byId: byId,
                arr: arr,
                widgets: widgets,
            });
        }
        case WidgetAction.DELETE: {
            const payload = (action as IWidgetAction).payload;
            const deleteWidget = payload.widget;

            const newState = assign({}, state);
            newState.arr = state.arr.filter((widgetId: string) => {
                return widgetId != deleteWidget.id;
            });
            newState.widgets = state.widgets.filter((widget: Widget) => {
                return widget.id != deleteWidget.id;
            });
            delete newState.byId[deleteWidget.id];

            return newState;
        }
        case WidgetAction.UPDATE_ALL: {
            const payload = (action as IReportTemplateAction).payload;
            const newWidgets = payload.widgets as Widget[];

            return assign({}, state, {
                arr: newWidgets.map(({id}) => {
                    return id;
                }),
                widgets: newWidgets.map(({id}) => {
                    return state.byId[id];
                }),
            });
        }
        case WidgetAction.UPDATE_SETTINGS: {
            const payload = (action as IWidgetAction).payload;
            const { widgetId, settings } = payload;
            const widget = state.byId[widgetId];

            if (!widget) {
                return state;
            }

            const newWidget = assign({}, widget, {
                settings: settings
            });

            const byId = assign({}, state.byId, {
                [newWidget.id]: newWidget
            });

            const widgets = state.arr.map((key: string) => {
                return byId[key];
            });

            return assign({}, state, {
                byId: byId,
                widgets: widgets,
            });
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/reducers/reportTemplate.ts